import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { useIsDesktopDimension } from '@beef/ui-kit';
import { Modal } from "../../../Modal";
import { ActionBar } from "../ActionBar";
import { EFetchStatus } from "../../../../store/slices/region";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var RegionModalLayout = function RegionModalLayout(_ref) {
  var isOpen = _ref.isOpen,
    fetchAllRegions = _ref.fetchAllRegions,
    status = _ref.status,
    toggleRegionModal = _ref.toggleRegionModal,
    children = _ref.children;
  var isDesktop = useIsDesktopDimension();
  useEffect(function () {
    if (isOpen && status !== EFetchStatus.loaded && status !== EFetchStatus.error) {
      fetchAllRegions();
    }
  }, [isOpen, fetchAllRegions, status]);
  return /*#__PURE__*/React.createElement(Modal, {
    actionBarNode: !isDesktop ? /*#__PURE__*/React.createElement(ActionBar, {
      onCloseButtonClick: toggleRegionModal
    }) : undefined,
    className: cn('region-modal'),
    closeOptions: {
      button: false,
      overlay: true,
      escape: true
    },
    isOpen: isOpen,
    onClose: toggleRegionModal,
    overlayClassName: cn('region-overlay'),
    portalClassName: cn('region-portal'),
    style: {
      zIndex: 555
    },
    theme: "light"
  }, children);
};